var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1217 20C10.6386 20 10.2177 19.8237 9.859 19.4711C9.50032 19.1185 9.32099 18.6997 9.32099 18.2149V13.2121L4.40203 6.84299C3.94819 6.2553 3.87866 5.63454 4.19341 4.98073C4.50817 4.32692 5.04618 4.00002 5.80744 4.00002H18.1927C18.9539 4.00002 19.492 4.32692 19.8067 4.98073C20.1215 5.63454 20.0519 6.2553 19.5981 6.84299L14.6791 13.2121V18.5234C14.6791 18.9495 14.5364 19.3021 14.2509 19.5813C13.9654 19.8604 13.6031 20 13.1639 20H11.1217Z",
    fill: "#5E6974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFilter);
export default __webpack_public_path__ + "static/media/table-filter.160cbbf66d07ec132476530b86d890a4.svg";
export { ForwardRef as ReactComponent };